import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { isApiHttpError, isSessionExpired } from '../api/apiErrors';
import { notifySessionExpired } from '../auth/sessionExpiry';

const NON_RETRYABLE = new Set([401, 403, 404, 409]);

/** Safe-GET retry only, max 1, never 401/403/404/409 (spec §11.1). */
function shouldRetry(failureCount: number, error: unknown): boolean {
  if (isApiHttpError(error) && NON_RETRYABLE.has(error.status)) return false;
  return failureCount < 1;
}

function onAnyError(error: unknown): void {
  if (isSessionExpired(error)) notifySessionExpired();
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: shouldRetry,
        refetchOnWindowFocus: false,
        staleTime: 5_000,
      },
      mutations: {
        retry: false,
      },
    },
    queryCache: new QueryCache({ onError: onAnyError }),
    mutationCache: new MutationCache({ onError: onAnyError }),
  });
}

export const queryClient = createQueryClient();
